/* eslint-disable no-inner-declarations */
import { DatabaseAdapter } from "@/configuration";
import log from "loglevel";

export async function sendUserResponse({ bot_id, conversation_id, query }) {
  try {
    return await DatabaseAdapter.sendUserResponseDB({
      bot_id,
      conversation_id,
      query,
    });
  } catch (error) {
    log.error(`use_case.sendUserResponse ERROR`, error);
    Promise.reject();
    throw Error("use_case.sendUserResponse ERROR");
  }
}
